import React, { ReactNode } from 'react';
import { Box, Types } from '@fiverr-private/theme';
import { FORM_LABEL_ID } from '../../constants';

const FormLabel = ({ children, htmlFor }: { children: ReactNode; htmlFor?: Types.Box['htmlFor'] }) => (
  <Box as="label" color="grey_1200" lineHeight="b_md" fontSize="b_md" htmlFor={htmlFor}>
    {children}
  </Box>
);

FormLabel.id = FORM_LABEL_ID;
FormLabel.displayName = FORM_LABEL_ID;

export default FormLabel;
